import { render, staticRenderFns } from "./LoginCadastro.vue?vue&type=template&id=6c688a2a&"
import script from "./LoginCadastro.vue?vue&type=script&lang=js&"
export * from "./LoginCadastro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports